import { apiSlice } from "../api"

export const contactApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    contactsList: builder.query({
      query: props => {
        let url = `/contact-us`
        if (props) {
          const {
            page = 1,
            limit = 10,
            status = "",
            type = "",
            search = "",
          } = props?.state
          url = `/contact-us?${type ? "category=" + type + "&" : ""}${
            status ? "status=" + status + "&" : ""
          }${search ? "search=" + search + "&" : ""}page=${page}&limit=${limit}`
        }
        return {
          url: `${url} `,
          method: "GET",
        }
      },
    }),
  }),
})
export const { useContactsListQuery } = contactApiSlice
